import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class BPGAdminHomeService {
  constructor(private readonly http:HttpClient,
    private readonly bpgCommonService:BpgCommonService ) { }

    URI : string = ConstantValues.userManagementApiUrl.userManagementUrl;
    homePageDataApi:  string = ConstantValues.userManagementApiUrl.getHomePageData;
    adminsChapterDetailsApi: string = ConstantValues.userManagementApiUrl.getAdminsChatperData;

      /** For service call to get bpg news list
   * @class DiHomePageService
   * @method getDiNewsList
   * @param landingData
   * @returns Observable
   **/

 getHomeData(ChapterExistsDTO:any): Observable<any> {
  return this.http.post(this.URI + this.homePageDataApi , ChapterExistsDTO, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;

  })).pipe(catchError((error: any) => {
    throw of(error);
  }))
}

getChapterData() {
  return this.http.get(this.URI+this.adminsChapterDetailsApi,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;
    }))
    .pipe(catchError((error: any) => {
      throw of(error);
    }))
 }
}
